import { JSONContent } from '@tiptap/react'

/** @description truncate a text formated in markdown */
export function truncateMarkdown(
  content: JSONContent,
  limit: number,
  totalCount: number = 0
): { content: JSONContent; count: number } | undefined {
  /** check if the limit was already achieved */
  if (totalCount >= limit) return

  const count = (content.text?.length ?? 0) + totalCount

  /** check if the limit is reached with this content text */
  if (count >= limit && content.text) {
    const substringSize = limit - (count - content.text.length)
    content.text = content.text.substring(0, substringSize)
    return { content, count: limit }
  }

  /** return early as it hasn't no more content children */
  if (!content.content?.length) return { content, count }

  /** recurse for each child content */
  const { totalCount: accumulatedCount, contents } = content.content.reduce(
    (acc: { totalCount: number; contents: JSONContent[] }, content) => {
      const contentTruncated = truncateMarkdown(content, limit, acc.totalCount)
      /** limit already achieved, ignoring this child */
      if (!contentTruncated) return acc

      return {
        totalCount: contentTruncated.count,
        contents: [...acc.contents, contentTruncated.content]
      }
    },
    { totalCount, contents: [] }
  )

  content.content = contents
  return { content, count: accumulatedCount }
}
